"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var typesafe_actions_1 = require("typesafe-actions");
var LoginAction;
(function (LoginAction) {
    LoginAction.ON_LOGIN_SUBMIT = 'ON_LOGIN_SUBMIT';
    LoginAction.ON_LOGIN_CLOSE_CLICK = 'ON_LOGIN_CLOSE_CLICK';
    LoginAction.TOGGLE_LOGIN_PANEL_ACTIVE = 'TOGGLE_LOGIN_PANEL_ACTIVE';
    LoginAction.SET_LOGIN_PANEL_ACTIVE = 'SET_LOGIN_PANEL_ACTIVE';
    LoginAction.SET_LOGIN_PANEL_DIM = 'SET_LOGIN_PANEL_DIM';
    LoginAction.SET_LOGIN_LOADING = 'SET_LOGIN_LOADING';
    LoginAction.SET_LOGIN_GLOBAL_ERROR = 'SET_LOGIN_GLOBAL_ERROR';
    LoginAction.FACEBOOK_LOGIN = 'FACEBOOK_LOGIN';
    LoginAction.ON_FACEBOOK_LOGINED = 'ON_FACEBOOK_LOGINED';
    LoginAction.LOGIN_SET_EMAIL = 'LOGIN_SET_EMAIL';
    LoginAction.SAVE_SEARCHSET_TO_LOCAL_STORAGE = 'SAVE_SEARCHSET_TO_LOCAL_STORAGE';
    LoginAction.onLoginSubmit = typesafe_actions_1.createAction(LoginAction.ON_LOGIN_SUBMIT, function (resolve) { return function (loginFields) {
        return resolve(loginFields);
    }; });
    LoginAction.onLoginCloseClick = typesafe_actions_1.createAction(LoginAction.ON_LOGIN_CLOSE_CLICK, function (resolve) { return function () {
        return resolve();
    }; });
    LoginAction.togglePanelActive = typesafe_actions_1.createAction(LoginAction.TOGGLE_LOGIN_PANEL_ACTIVE, function (resolve) { return function () {
        return resolve();
    }; });
    LoginAction.setPanelActive = typesafe_actions_1.createAction(LoginAction.SET_LOGIN_PANEL_ACTIVE, function (resolve) { return function (state) {
        return resolve(state);
    }; });
    LoginAction.setPanelDim = typesafe_actions_1.createAction(LoginAction.SET_LOGIN_PANEL_DIM, function (resolve) { return function (state) {
        return resolve(state);
    }; });
    LoginAction.setLoading = typesafe_actions_1.createAction(LoginAction.SET_LOGIN_LOADING, function (resolve) { return function (state) { return resolve(state); }; });
    LoginAction.setGlobalError = typesafe_actions_1.createAction(LoginAction.SET_LOGIN_GLOBAL_ERROR, function (resolve) {
        return function (errorMessage) { return resolve(errorMessage); };
    });
    LoginAction.facebookLogin = typesafe_actions_1.createAction(LoginAction.FACEBOOK_LOGIN, function (resolve) {
        return function () { return resolve(); };
    });
    LoginAction.onFacebookLogined = typesafe_actions_1.createAction(LoginAction.ON_FACEBOOK_LOGINED, function (resolve) {
        return function (hasMerge) { return resolve(hasMerge); };
    });
    LoginAction.setEmail = typesafe_actions_1.createAction(LoginAction.LOGIN_SET_EMAIL, function (resolve) {
        return function (email) { return resolve(email); };
    });
    LoginAction.saveSearchSetToLocalStorage = typesafe_actions_1.createAction(LoginAction.SAVE_SEARCHSET_TO_LOCAL_STORAGE, function (resolve) {
        return function (email) { return resolve(email); };
    });
})(LoginAction || (LoginAction = {}));
exports.default = LoginAction;
